import styled from "styled-components";
import fipayFonts from "../../../theme/index";
import { colors } from "../../../theme/color";

export const ValuesContainer = styled.div`
  width: 100%;
  height: 647px;
  padding: 70px 0px;

  background: var(--General-Background, #f7f7f7);

  @media screen and (max-width: 1024px) {
    /* width: 768px;
    height: 1400px;
    padding: 60px 88px 60px 8px; */
    height: 547px;
  }
  @media screen and (max-width: 768px) {
    width: 768px;
    height: 1400px;
    padding: 60px 8px 60px 8px;
    box-sizing: border-box;
  }

  @media screen and (max-width: 430px) {
    width: 100%;
    height: 1262px;
    padding-top: 62px;
    /* padding-bottom: 74px; */
  }
  @media screen and (max-width: 375px) {
    width: 375px;
    height: 1262px;
    padding-top: 62px;
    /* padding-bottom: 74px; */
  }
  @media screen and (max-width: 320px) {
    width: 100%;
    height: 1262px;
    padding-top: 62px;
    /* padding-bottom: 74px; */
  }
`;
export const ValuesContainer1 = styled.div`
  width: 100%;
  height: 1010px;
  padding: 70px 0px;

  background: var(--General-Background, #f7f7f7);

  @media screen and (max-width: 1024px) {
    /* width: 768px; */
    height: 2440px;
    /* padding: 60px 88px 60px 8px; */
    height: 547px;
  }
  @media screen and (max-width: 768px) {
    width: 768px;
    height: 2470px;
    padding: 60px 8px 60px 8px;
    box-sizing: border-box;
  }

  @media screen and (max-width: 430px) {
    width: 100%;
    height: 2440px;
    padding-top: 62px;
    /* padding-bottom: 74px; */
  }
  @media screen and (max-width: 375px) {
    width: 375px;
    height: 2440px;
    padding-top: 62px;
    /* padding-bottom: 74px; */
  }
  @media screen and (max-width: 320px) {
    width: 100%;
    height: 2440;
    padding-top: 62px;
    /* padding-bottom: 74px; */
  }
`;

export const ModuleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }

  @media screen and (max-width: 375px) {
    flex-direction: column;
  }
`;
export const ModuleContainer1 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  flex-wrap: wrap;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }

  @media screen and (max-width: 375px) {
    flex-direction: column;
  }
`;
